import { DownOutlined, SearchOutlined, SettingOutlined } from '@ant-design/icons';
import type { ColDef, GridApi, SelectionChangedEvent } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { ConfigProvider, Input, Pagination, Select, TreeSelect } from 'antd';
import viVN from 'antd/locale/vi_VN';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { NodataTable } from '../../../../../../components/NoDataTable';
import { useCustomerGroupContext } from '../../../indexV2';
import '../../../style.scss';
import { AddType, ISelectedCustomer, type IDataFilterGroupList, type IInforAddGroup, type IPagination } from '../AddNewGroup';
import { formatNumber } from '../../../../../../services/mixin';
import { formatPrice } from '../../../../../../until';


interface Props {
    memoizedColumnDefs: ColDef<any, any>[];
    paginationCustomers: IPagination;

    inforAddGroup: IInforAddGroup
    selectedIdCustomerV9: ISelectedCustomer[]

    setSelectedIdCustomerV9: React.Dispatch<React.SetStateAction<ISelectedCustomer[]>>

    onPaginationCustomers: (page: number, pageSize: number) => void;


    //Kh có dk--------------------
    dataFilterListNoCondCustomers: IDataFilterGroupList;
    listCustomerNoAutomatic: any[];
    setDataFilterListNoCondCustomers: (dataFilterListNoCondCustomers: IDataFilterGroupList) => void;
    //Kh có dk--------------------

}

const AG_PrivateNoAutomatic: React.FC<Props> = ({
    memoizedColumnDefs,
    paginationCustomers,
    listCustomerNoAutomatic,

    inforAddGroup,
    selectedIdCustomerV9,

    setSelectedIdCustomerV9,

    onPaginationCustomers,

    dataFilterListNoCondCustomers,
    setDataFilterListNoCondCustomers,
}) => {

    const {
        // sLUnit, sLCategoryCar,
        sLCategoryCar, sLNationwide,
        handleOpenDataFields
    } = useCustomerGroupContext();


    const isRestoringSelection = useRef(false);
    const gridApiRef = useRef<GridApi | null>(null);

    const [selectedIds, setSelectedIds] = useState<Set<Number>>(new Set());


    //------------------------------------ Start SELECT
    // Định danh duy nhất cho mỗi row
    const getRowId = useCallback((p: { data: any }) => String(p.data.id), []);

    // --- Grid ready ---
    const onGridReady = useCallback((params: { api: GridApi }) => {
        gridApiRef.current = params.api;
    }, []);

    // --- Selection change ---
    const onSelectionChanged = useCallback((event: SelectionChangedEvent) => {
        if (isRestoringSelection.current) return;

        const api = event.api;
        const selectedNodes = api.getSelectedNodes().filter(n => n.data);
        const selectedIdsOnPage = selectedNodes.map(n => Number(n.data.id));

        const currentPageIds = (listCustomerNoAutomatic ?? []).map((row: any) => Number(row.id));

        // --- Tạo bản sao của selectedIds hiện tại ---
        const nextSet = new Set(selectedIds);

        // --- Xác định phần tử được thêm và bị xóa trên trang HIỆN TẠI ---
        const added: number[] = [];
        const removed: number[] = [];

        // Kiểm tra từng ID trên trang hiện tại
        for (const id of currentPageIds) {
            const isCurrentlySelected = selectedIdsOnPage.includes(id);
            const wasPreviouslySelected = selectedIds.has(id);

            if (isCurrentlySelected && !wasPreviouslySelected) {
                // ID mới được chọn
                added.push(id);
                nextSet.add(id);
            } else if (!isCurrentlySelected && wasPreviouslySelected) {
                // ID bị bỏ chọn
                removed.push(id);
                nextSet.delete(id);
            }
        }

        setSelectedIds(nextSet);

        // 👉 Cập nhật danh sách selected account
        handleChangeSelectedCustomer(added, removed);
    }, [selectedIds, listCustomerNoAutomatic]);


    // --- Cập nhật danh sách account được chọn ---
    const handleChangeSelectedCustomer = (itemsAdd: number[] = [], itemsRemove: number[] = []) => {
        setSelectedIdCustomerV9((prev) =>
            itemsAdd.length ?
                [
                    ...prev,
                    ...itemsAdd
                        .filter((id) => !prev.some((u) => u.customerId === id))
                        .map((id) => ({ customerId: id, addType: AddType.Manual })),
                ] :
                itemsRemove.length ?
                    prev.filter((u) => !itemsRemove.includes(u.customerId)) :
                    prev
        );
    };

    // --- Khôi phục selection khi data mới load ---
    useEffect(() => {
        if (gridApiRef.current && listCustomerNoAutomatic && listCustomerNoAutomatic.length > 0) {
            isRestoringSelection.current = true;

            gridApiRef.current.forEachNode((node: any) => {
                if (node.data && selectedIds.has(Number(node.data.id))) {
                    node.setSelected(true, false, true);
                } else {
                    node.setSelected(false, false, true);
                }
            });

            setTimeout(() => {
                isRestoringSelection.current = false;
            }, 0);
        }
    }, [listCustomerNoAutomatic, selectedIds]);

    //------------------------------------ End SELECT

    useEffect(() => {
        const Ids = new Set(
            selectedIdCustomerV9.map(item => item.customerId)
        );
        setSelectedIds(Ids);
    }, [selectedIdCustomerV9])

    return (
        <div className="custom-page-css w-full flex flex-col gap-2 bg-white p-4 rounded">
            {/* Header */}
            <div className="custom-page-css flex gap-2 items-center">
                <span className="custom-page-css text-base font-regular">Danh sách khách hàng</span>
            </div>

            {/* Filters */}
            <div className="custom-page-css flex items-start gap-2">
                <div className="custom-page-css h-fit flex-1 d-flex  gap-2 overflow-hidden">
                    <div className="w-full border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center  py-2-px justify-between overflow-hidden">
                        <div className="d-flex align-center w-full">

                            <TreeSelect
                                className="w-full text-left text-span-select custom-input-focus text-sm bg-FCFCFD-ant-select font-regular p-none-select line-none line-none-item inline-none size-selector border-none"

                                multiple
                                showSearch
                                placeholder="Chọn đơn vị"
                                allowClear
                                value={dataFilterListNoCondCustomers?.listUnit}
                                treeDefaultExpandAll={false}
                                treeData={sLNationwide}
                                filterTreeNode={(input: string, option: any) =>
                                    typeof option?.label === 'string' && option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                onChange={(e) => setDataFilterListNoCondCustomers({ ...dataFilterListNoCondCustomers, listUnit: e })}
                            />
                        </div>
                    </div>
                </div>

                <div className="custom-page-css h-fit flex-1 d-flex gap-2 overflow-hidden">
                    <div className="w-full border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center  py-2-px justify-between overflow-hidden">
                        <div className="d-flex align-center w-full">
                            <Select
                                showSearch={false}
                                allowClear
                                mode="multiple"
                                className="w-full text-left text-span-select text-sm bg-FCFCFD-ant-select font-regular p-none-select line-none line-none-item inline-none size-selector border-none"
                                popupClassName="position-dropdow custome-select-item h-popUp"
                                variant="borderless"
                                placeholder="Thương hiệu"
                                options={sLCategoryCar}
                                value={dataFilterListNoCondCustomers?.listCategoryCar}
                                onChange={(e) => setDataFilterListNoCondCustomers({ ...dataFilterListNoCondCustomers, listCategoryCar: e })}
                            />
                        </div>
                    </div>
                </div>
                <div className="custom-page-css h-fit flex-2 border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center pl-3 py-2-px justify-between overflow-hidden">
                    <Input
                        placeholder="Tìm kiếm thông tin khách hàng"
                        className='custom-input-css custom-page-css border-none custom-input-focus  none-focus-erro'
                        value={dataFilterListNoCondCustomers.search}
                        onChange={(e) => setDataFilterListNoCondCustomers({ ...dataFilterListNoCondCustomers, search: e.target.value })}
                    />
                    <div className="border-l-F2F4F7 h-full d-flex align-center">
                        <SearchOutlined className="text-sm text-98A2B3 px-9-px" />
                    </div>
                </div>
            </div>

            {/* Counter */}

            <div className="custom-page-css flex items-center justify-betweeen gap-1">
                <div className="custom-page-css flex items-center gap-1">
                    <span className="custom-page-css text-base text-4B4B4B font-regular">Đã chọn:</span>
                    <span className="custom-page-css text-base text-344054 font-regular">{formatPrice(selectedIdCustomerV9.length)} khách hàng</span>
                </div>
                <div className="custom-page-css flex items-center justify-end gap-2">
                    <div className="btn-input t-px-8 cursor-pointer"
                        onClick={handleOpenDataFields}
                    >
                        <div className="icon-svg">
                            <SettingOutlined />
                        </div>
                    </div>
                </div>
            </div>
            {/* Grid */}
            <div className={`order-history-card__body `}>
                <div className="ag-theme-alpine  custom-table-ag" style={{ width: '100%', height: 610 }}>
                    <AgGridReact
                        className="my-auto-height-grid"
                        getRowStyle={(params: any) => ({
                            backgroundColor: params?.node?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
                        })}
                        columnDefs={memoizedColumnDefs}
                        rowData={listCustomerNoAutomatic}
                        rowHeight={55}
                        defaultColDef={{
                            resizable: true
                        }}
                        overlayNoRowsTemplate={NodataTable}
                        rowSelection={{ mode: 'multiRow' }} selectionColumnDef={{ pinned: 'left', lockPosition: 'left', suppressMovable: true }}
                        getRowId={getRowId}
                        onGridReady={onGridReady}
                        onSelectionChanged={onSelectionChanged}

                        alwaysShowHorizontalScroll
                        alwaysShowVerticalScroll
                    />
                </div>

                {/* Pagination */}
                <ConfigProvider locale={viVN}>
                    <div className="pagination-block">
                        <Pagination
                            showSizeChanger
                            current={paginationCustomers.current}
                            pageSize={paginationCustomers.pageSize}
                            total={paginationCustomers.total}
                            itemRender={(page, type, originalElement) => {
                                // Chỉ custom khi là nút số trang
                                if (type === 'page') {
                                    return <span>{formatNumber(page)}</span>;
                                }
                                // prev / next / jump-prev / jump-next giữ nguyên
                                return originalElement;
                            }}
                            className="rs-pagination"
                            onChange={onPaginationCustomers}
                        />
                    </div>
                </ConfigProvider>
            </div>
        </div>
    );
};

export default React.memo(AG_PrivateNoAutomatic)